import PropTypes from 'prop-types';
import React, { memo, forwardRef } from 'react';
import { Input as RInput } from 'rsuite';
import styled from 'styled-components';

export const StyledInput = styled(RInput)`
  border-radius: 4px;

  .rs-input-lg {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  :hover,
  :focus {
    border-color: #37a3bc !important;
  }
`;

// Use forwardRef to properly handle refs passed from parent components
const InputWrapper = forwardRef((props, ref) => {
  return <StyledInput {...props} ref={ref} />;
});

InputWrapper.propTypes = {
  placeholder: PropTypes.string,
};

// Memoized input for forms
export const Input = memo(InputWrapper);
